import { cloneDeep } from 'lodash';
import React from 'react';
import { shallow } from 'zustand/shallow';

import Icon from '@ant-design/icons';
import { useMappingPanelStore } from '@components/mapping-panel/store';
import { transformRulesToState } from '@components/mapping-panel/utils/handleRulesUtils';
import { useTopPanelStore } from '@hooks';
import ViewDetailIcon from '@src/icons/emp/view_detial.svg';
import { trackClickEditMappedEvent } from '@src/sensor';
import PermissionButton from '@src/emp-3.0/components/PermissionButton';

interface IProps {
  event: any;
}

const MappedEventMenu: React.FC<IProps> = ({ event }) => {
  const [setMappedEvent, setEventCategory, setMappedName, setMappingRules] = useMappingPanelStore(
    (state) => [
      state.setMappedEvent,
      state.setEventCategory,
      state.setMappedName,
      state.setMappingRules,
    ],
    shallow,
  );
  const { openMappingPanel } = useTopPanelStore();

  const storage_predefined_mapped_event = event?.storage_predefined_mapped_event;

  const handleEditMappedEvent = (e) => {
    if (storage_predefined_mapped_event) return;
    trackClickEditMappedEvent({
      ...event,
    });
    e.stopPropagation();
    // To prevent data reference issues, edited event information is not saved, but the original information is still saved.
    const clonedEvent = cloneDeep(event);
    openMappingPanel();
    setMappedEvent(clonedEvent);
    setEventCategory(clonedEvent.event_category);
    setMappedName(clonedEvent.event_name);
    setMappingRules(transformRulesToState(clonedEvent.rules));
  };
  return (
    <PermissionButton
      onClick={handleEditMappedEvent}
      disabledStyle={{ color: 'rgba(0, 0, 0, 0.65)' }}
      lackPermissionToolTip="Non-Admin Permission, go to management for details"
    >
      <Icon
        style={{
          cursor: storage_predefined_mapped_event ? 'not-allowed' : 'pointer',
          height: '100%',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...(storage_predefined_mapped_event ? { color: 'rgba(0, 0, 0, 0.65)' } : {}),
        }}
        disabled={storage_predefined_mapped_event}
        component={ViewDetailIcon}
      />
    </PermissionButton>
  );
};

export default MappedEventMenu;
